import { getPlatformSettings } from './usePlatformSettings'

export function getWalletLink() {
    return window.condaWalletLink
}

export function getOrdersLink() {
    return window.condaOrdersLink
}

export function getAccountLink() {
    return window.condaAccountLink
}

export function showWalletLink() {
    return window.condaShowWalletLink
}

export function showOrdersLink() {
    return window.condaShowOrdersLink
}

export function getLoginLink() {
    return window.condaKeycloakLoginLink
}

export function getRegisterLink() {
    return window.condaKeycloakRegisterLink
}

export function getKeycloakLoginLink() {
    return window.condaKeycloakLoginLink
}

export function getKeycloakRegisterLink() {
    return window.condaKeycloakRegisterLink
}

export function getSecondaryMarketLink(): string {
    return getPlatformSettings()?.sm_frontend_url || ''
}

export function showSecondaryMarketLink(): boolean {
    return getPlatformSettings()?.sm_marketplace ?? false
}
